/**
 * Los años de experiencia de un candidato, como se leen en pantalla.
 *
 * El tipo dice `number`, pero por la API llega nulo en los candidatos que se
 * dieron de alta a mano sin capturarlo: la pantalla mostraba «null años».
 * TypeScript no lo veía porque el campo está declarado obligatorio y no lo es.
 *
 * Vive aquí y no dentro de una pantalla porque estaba escrito dos veces —en el
 * detalle del candidato y en el listado— con el mismo defecto en las dos.
 */
export function experienciaDelCandidato(anios?: number | null): string {
  if (anios === null || anios === undefined) return 'No especificada'

  // Una cadena vacía se cuela como cero —`Number('')` es 0— y diría «Sin
  // experiencia», que afirma algo que nadie capturó.
  if (typeof anios === 'string' && (anios as string).trim() === '') {
    return 'No especificada'
  }

  // Un texto que no se puede leer como número es tan poco informativo como la
  // ausencia del dato, y «NaN años» es peor que no decir nada.
  const numero = typeof anios === 'number' ? anios : Number(anios)
  if (!Number.isFinite(numero) || numero < 0) return 'No especificada'

  if (numero === 0) return 'Sin experiencia'
  if (numero === 1) return '1 año'

  return `${numero} años`
}
